import { Tabs } from "@mantine/core";
import { useScrollSpy } from "@mantine/hooks";
import { useEffect, useState } from "react";

interface TableOfContentsTabsProps {
  scrollAreaViewportRef: HTMLDivElement;
}

export const TableOfContentsTabs = ({
  scrollAreaViewportRef,
}: TableOfContentsTabsProps) => {
  const SCROLL_THRESHOLD = 100;
  const [showTabs, setShowTabs] = useState(false);

  const spy = useScrollSpy({
    selector:
      "#campground-details-modal .mantine-Modal-body :is(h1, h2, h3, h4, h5, h6)",
    scrollHost: scrollAreaViewportRef,
    offset: 80,
  });

  const handleScroll = () => {
    setShowTabs(scrollAreaViewportRef.scrollTop > SCROLL_THRESHOLD);
  };

  useEffect(() => {
    scrollAreaViewportRef.addEventListener("scroll", handleScroll);
    return () => {
      scrollAreaViewportRef.removeEventListener("scroll", handleScroll);
    };
  }, [scrollAreaViewportRef]);

  const headings = spy.data;
  if (headings.length === 0) {
    return null;
  }

  return (
    <Tabs
      pos={"sticky"}
      style={{
        opacity: showTabs ? 1 : 0,
        height: showTabs ? 36 : 0,
        transition: "opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        pointerEvents: showTabs ? "auto" : "none",
        top: "60px",
        backgroundColor: "var(--mantine-color-body)",
        zIndex: 1,
        "--tab-border-color": "transparent",
      }}
      value={spy.data[spy.active].id}
      onChange={(newHeadingId) => {
        if (!newHeadingId) return;
        const element = spy.data
          .find((heading) => heading.id === newHeadingId)
          ?.getNode();
        if (element) {
          // Calculate scroll position with offset to account for sticky navbar
          const elementTop = element.offsetTop;
          const modalHeaderHeight = 60; // Modal header height
          const tabsNavbarHeight = 36; // Tabs navbar height
          const offset = modalHeaderHeight + tabsNavbarHeight;

          scrollAreaViewportRef.scrollTo({
            top: elementTop - offset,
            behavior: "smooth",
          });
        }
      }}
    >
      <Tabs.List>
        {headings.map((heading) => (
          <Tabs.Tab key={heading.id} value={heading.id}>
            {heading.value}
          </Tabs.Tab>
        ))}
      </Tabs.List>
    </Tabs>
  );
};
